import {Grid} from "@mui/material";
import Portada_Servicios from "./Componentes/Portada_Servicios";
import Soluciones_Servicios from "./Componentes/Soluciones_Servicios";
import Enfoque_Servicios from "./Componentes/Enfoque_Servicios";
import { Helmet } from "react-helmet";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import Contacto_Home from "./Componentes/Contacto_Home";

const Seccion_Servicios = () => {
    const {sCell} = useResponsive();
    return (
        <>
            <Helmet>
                {/* 🔹 TITLE */}
                <title>
                    Servicios de Mantenimiento Locativo en Cali | Adecuaciones y SST
                </title>
                <meta
                    name="description"
                    content="Servicios de mantenimiento locativo y adecuaciones en Cali para empresas, con cumplimiento SST y continuidad operativa."
                />
                <meta
                    name="keywords"
                    content="servicios mantenimiento locativo Cali, adecuaciones locativas Cali, SST obras Cali, infraestructura locativa empresas"
                />
                <meta name="robots" content="index, follow" />

                <link rel="canonical" href="https://espaciocompacto.com/servicios/" />

                {/* 🔹 GEO */}
                <meta name="geo.region" content="CO-VAL" />
                <meta name="geo.placename" content="Cali" />

                {/* 🔹 OPEN GRAPH */}
                <meta property="og:title" content="Servicios de Mantenimiento Locativo en Cali" />
                <meta property="og:description" content="Adecuaciones locativas y servicios técnicos en Cali para empresas con cumplimiento SST." />
                <meta property="og:image" content="https://espaciocompacto.com/Espaci_Compacto.png" />
                <meta property="og:url" content="https://espaciocompacto.com/servicios/" />
                <meta property="og:type" content="website" />

                {/* 🔹 TWITTER */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Servicios de Mantenimiento Locativo en Cali" />
                <meta name="twitter:description" content="Servicios técnicos en Cali para empresas y copropiedades." />
                <meta name="twitter:image" content="https://espaciocompacto.com/Espaci_Compacto.png" />

                {/* 🔹 JSON-LD (SERVICES) */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Service",
                        serviceType: "Mantenimiento Locativo",
                        provider: {
                            "@type": "LocalBusiness",
                            name: "Espacio Compacto",
                            areaServed: "Cali"
                        },
                        areaServed: {
                            "@type": "City",
                            name: "Cali"
                        },
                        hasOfferCatalog: {
                            "@type": "OfferCatalog",
                            name: "Servicios de Mantenimiento Locativo",
                            itemListElement: [
                                {
                                    "@type": "Offer",
                                    itemOffered: {
                                        "@type": "Service",
                                        name: "Adecuaciones Locativas en Cali"
                                    }
                                },
                                {
                                    "@type": "Offer",
                                    itemOffered: {
                                        "@type": "Service",
                                        name: "Mantenimiento Locativo Empresarial"
                                    }
                                },
                                {
                                    "@type": "Offer",
                                    itemOffered: {
                                        "@type": "Service",
                                        name: "SST en Obras Locativas"
                                    }
                                }
                            ]
                        }
                    })}
                </script>
            </Helmet>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt: 12}}>
                    <Portada_Servicios/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt:sCell?8:16}}>
                    <Enfoque_Servicios/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt:sCell?8:16}}>
                    <Soluciones_Servicios/>
                </Grid>

                <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                    <Contacto_Home />
                </Grid>

            </Grid>
        </>
    )

}
export default Seccion_Servicios